<template>
  <ion-toolbar>
    <slot>
      <ion-thumbnail name="start">
        <img
          :src="logo"
          :alt="title"
        >
      </ion-thumbnail>
    </slot>
    <ion-title v-if="title" class="header-title">
      {{ title }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        v-if="user.id"
        class="mr-10"
        @click="$router.push({ name: 'cart' })"
      >
        <ion-icon
          slot="icon-only"
          :icon="cart"
        />
      </ion-button>
      <ion-menu-toggle>
        <ion-button>
          <ion-icon
            slot="icon-only"
            :icon="menuOutline"
          />
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
  </ion-toolbar>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonThumbnail,
  IonButton,
  IonButtons,
  IonMenuToggle,
  IonToolbar,
} from '@ionic/vue';
import {
  ellipsisHorizontalOutline,
  menuOutline,
  cart,
  person,
  arrowForwardCircleOutline,
  searchOutline,
} from 'ionicons/icons';
import UserMixin from '@/mixins/UserMixin';

export default defineComponent({
  components: {
    IonThumbnail,
    IonButton,
    IonButtons,
    IonMenuToggle,
    IonToolbar,
  },
  mixins: [UserMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup() {
    return {
      ellipsisHorizontalOutline,
      menuOutline,
      cart,
      person,
      arrowForwardCircleOutline,
      searchOutline,
    };
  },
  computed: {
    logo() {
      return `img/${import.meta.env.VUE_APP_HANDLE}/logo.svg`;
    },
  },
});
</script>

<style scoped>
.mr-10 {
  margin-right: 10px;
}

ion-thumbnail {
  margin-left: 6px;

  img {
    object-fit: contain;
  }
}

.header-title {
  @media screen and (max-width: 576px) {
    font-size: 16px;
  }

  @media screen and (max-width: 375px) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
